import type {
  IBannerMessage,
  IMessage,
  IPopupMessage,
  IReadPopupMessageRequest,
} from "@services/messages/types";
import { api } from "@/api";

export const getMessages = (): Promise<IMessage[]> =>
  api.get<IMessage[]>("/messages").then((r) => r.data);

export const readMessage = (messageId: IMessage["messageId"]): Promise<void> =>
  api.put(`/messages/${messageId}/read`);

export const removeMessage = (
  messageId: IMessage["messageId"],
): Promise<void> => api.delete(`/messages/${messageId}`);

export const getPopupMessages = async (): Promise<IPopupMessage[]> =>
  (await api.get<IPopupMessage[]>("/messages/pop-ups")).data;

export const readPopupMessage = async (data: IReadPopupMessageRequest) =>
  (await api.put<void>(`/messages/pop-ups/${data.popUpId}/read`)).data;

export const getBannerMessages = (): Promise<IBannerMessage[]> =>
  api.get<IBannerMessage[]>("/messages/banners").then((r) => r.data);

export const removeBannerMessage = (
  bannerType: string,
): Promise<IBannerMessage[]> =>
  api
    .put<IBannerMessage[]>(`/messages/banners/${bannerType}`)
    .then((r) => r.data);
